import { AuthenticationWrapper } from '@bestseller-bit/frontend-community.utilities.authentication';
import { FC, PropsWithChildren } from 'react';
import { EnvironmentVariableError } from 'src/domain';

const clientId = import.meta.env.VITE_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID;
if (!clientId) throw new EnvironmentVariableError('Azure client ID not set');

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
    return (
        <AuthenticationWrapper
            clientId={clientId}
            tenantId="98db9fb9-f52b-4e63-83d9-795ccd2dfcca"
            redirectUri={`${globalThis.location.origin}/login.html`}
            preventAutomaticLogin
            isPopup
        >
            {children}
        </AuthenticationWrapper>
    );
};
